import React from "react"
import { useTranslation } from "react-i18next"
import clsx from "clsx"

import { thousandSeparator } from "utils"
import classes from "./CheckoutPaymentListFooter.module.scss"

const CheckoutPaymentListFooter = props => {
  const { total, cashTypes } = props

  const [t, i18n] = useTranslation()

  const sumOfPayments =
    cashTypes.reduce((t, cashType) =>
      t += Number(cashType.amount)
      , 0
    )

  const change = total - sumOfPayments

  const showChange = cashTypes.length === 0

  const isLtr = i18n.dir(i18n.language) === "ltr"

  if (showChange) return null

  return (
    <div className={classes["container"]}>
      <span>{t("مانده")}</span>{" "}
      <span
        className={clsx(
          classes["change"],
          isLtr && classes["change-ltr"]
        )}
      >
        {thousandSeparator(change)}
      </span>
    </div>
  )
}

export default CheckoutPaymentListFooter